import React from 'react';
import ConfluenceHomeBannerPlacementComponent from '@post-office-placement/confluence-home-banner/placement';

import { PlacementFetchProvider } from '@atlassian/confluence-post-office-provider/entry-points/preload-placement';
import { Placement } from '@atlassian/post-office-placement';

import { Attribution, withTransparentErrorBoundary } from '@confluence/error-boundary';

const PLACEMENT_ID = 'confluence-home-banner';

export const HomeBanner = () => {
	return (
		<div role="banner">
			<PlacementFetchProvider>
				<Placement
					placementId={PLACEMENT_ID}
					// @ts-ignore - Type 'ComponentType<Partial<ErrorBoundaryPropsWithRender>> is not assignable to type 'PlacementComponent<LocalPlacementProps>'
					PlacementComponent={ConfluenceHomeBannerPlacementComponent}
				/>
			</PlacementFetchProvider>
		</div>
	);
};

export const PostOfficeHomeBanner = withTransparentErrorBoundary({
	attribution: Attribution.POST_OFFICE,
})(HomeBanner);
